const typeModal = (() => {
  if (document.querySelector("body#pageType") !== null) {
    if (document.querySelector("section#jsSecModal") !== null) {



      MicroModal.init({
        disableScroll: true,
        awaitOpenAnimation: true,
        awaitCloseAnimation: true,
        disableFocus: true,
        onShow: modal => console.info(`${modal.id} is shown`), // [1]
        onClose: modal => console.info(`${modal.id} is hidden`), // [2]
      });
      // MicroModal.show('modal-1');



    }
  }
})()
export default typeModal;